import React from 'react'
import Heading from './Heading'
import { Link } from 'gatsby'

export default function DualInfoBlock({heading}) {
    return (
        <section className="bg-theme my-5 py-4">
        
        <div className="container">
            <Heading title={heading}/>
            <div className="row">
                <div className="col-10 col-sm-8 mx-auto text-center">
                    <p className="lead text-dark mb-4">
                    <b>Payment Gateway service is in varifications process . <br/> For Placing the orders please go to Contact Us Page.</b>
                    </p>
                    <Link to="/contact/" >
                        <button className = "btn btn-warning btn-lb">Contact Us</button>
                    </Link>
                </div>
            </div>
        </div>
    
    </section>
    )
}
